
export const ApplyFilter = ({ onFilter }) => {
    return <button
    className="btn btn-sm btn-secondary mt-lg-3"
    onClick={onFilter}
  >
    Apply Filter
  </button>;
}